import React from 'react';
import { Button } from '../../../components/ui/Button';
import { Spinner } from '../../../components/ui/Spinner';
import { getLoginPathForCurrentSession } from '../../../utils/loginPortal';
import type { LmsLaunchErrorPresentation } from '../../../utils/lmsLaunchErrors';

type EmbedShellProps = {
  phase: 'waiting' | 'launching' | 'error';
  errorPresentation?: LmsLaunchErrorPresentation;
  onRetry?: () => void;
};

export const EmbedShell: React.FC<EmbedShellProps> = ({
  phase,
  errorPresentation,
  onRetry,
}) => {
  if (phase === 'error' && errorPresentation) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4">
        <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="text-lg font-semibold text-slate-900">{errorPresentation.title}</h1>
          <p className="mt-2 text-sm text-slate-600">{errorPresentation.message}</p>
          {errorPresentation.supportHint && (
            <p className="mt-3 text-xs text-slate-500">{errorPresentation.supportHint}</p>
          )}
          {errorPresentation.code && (
            <p className="mt-2 font-mono text-xs text-slate-400">Code: {errorPresentation.code}</p>
          )}
          <div className="mt-6 flex flex-col gap-2 sm:flex-row">
            {errorPresentation.canRetry && onRetry && (
              <Button type="button" onClick={onRetry}>
                Try again
              </Button>
            )}
            <Button
              type="button"
              variant="secondary"
              onClick={() => {
                window.location.href = getLoginPathForCurrentSession();
              }}
            >
              Go to sign in
            </Button>
          </div>
        </div>
      </div>
    );
  }

  const label =
    phase === 'launching'
      ? 'Signing you in from your learning portal…'
      : 'Waiting for your learning portal…';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-4">
      <Spinner size="lg" />
      <p className="text-center text-slate-600">{label}</p>
    </div>
  );
};
